import axiosClient from "../axiosClient";
import type { AxiosResponse } from "axios";
import type { UserBooking } from "@/pages/UserBookings/store/types";
import type { TimeSlotGroup } from "@/pages/BookSlot/store/types";

export type BookTimeSlotReqInput = {
  slots: number[];
};

export const getMobileUserBookingsReq = async (): Promise<
  AxiosResponse<UserBooking[]>
> => {
  const response = await axiosClient.get<UserBooking[]>(
    `/access/group/mobile/list/with-booked-time-slots`
  );
  return response;
};

export const getAvailableTimeSlotsGroupReq = async (
  id: string,
  month: string,
  year: string
): Promise<AxiosResponse<TimeSlotGroup>> => {
  const response = await axiosClient.get<TimeSlotGroup>(
    `/access/group/${id}/available-time-slots?month=${month}&year=${year}`
  );
  return response;
};

export const bookTimeSlotReq = async (
  data: BookTimeSlotReqInput
): Promise<AxiosResponse> => {
  return await axiosClient.post("/access/time-slots/book", data);
};

export const deleteTimeSlotBookingReq = async (id: number) => {
  return await axiosClient.delete<undefined, AxiosResponse<undefined>>(
    `/access/time-slots/book/${id}`
  );
};
